export const colMin = {
  classes: "w-10",
  dataField: "min",
  formatter: (col: any, row: any) => {
    return <>{row.type && row.type === "TEXT" ? "<>" : row.min}</>;
  },
  text: "Min",
};

export const colMax = {
  classes: "w-10",
  dataField: "max",
  formatter: (col: any, row: any) => {
    return <>{row.type && row.type === "TEXT" ? "<>" : row.max}</>;
  },
  text: "Max",
};
